import {StyleSheet, View} from 'react-native'
import {useReducedMotion} from 'react-native-reanimated'
import {Feather} from '@expo/vector-icons'
import {DotLottieReact} from '@lottiefiles/dotlottie-react'

import seekArrowData from '../../../../assets/capsule/lottie/seek-arrow.json'

export type SeekArrowDir = 'back' | 'fwd'

/**
 * SeekArrow (web) — the animated seek-arrow badge from the capsule design
 * (arrow whooshing into a soft disc), used inside the transport seek chips.
 *
 * The animation is ONE-SHOT and starts from frame 0 on every mount: the
 * transport layer remounts the chip (new key) on every seek/burst click, so a
 * rapid click series replays the whoosh each time. `dir='fwd'` mirrors it
 * horizontally (the asset chevron points back/left by default).
 *
 * Reduced-motion users get a static Feather arrow instead of the whoosh.
 */
export function SeekArrow({
  dir,
  size = 46,
}: {
  dir: SeekArrowDir
  size?: number
}) {
  const reducedMotion = useReducedMotion()

  if (reducedMotion) {
    return (
      <View
        style={[
          styles.staticWrap,
          {width: size, height: size},
          dir === 'fwd' && styles.flip,
        ]}>
        <Feather
          name={dir === 'back' ? 'arrow-left' : 'arrow-right'}
          size={size * 0.42}
          color="rgba(255,255,255,0.95)"
        />
      </View>
    )
  }

  return (
    <View
      style={[
        {width: size, height: size},
        dir === 'fwd' && styles.flip,
      ]}
      pointerEvents="none">
      {/* @ts-ignore data is web-only — plain Lottie JSON object */}
      <DotLottieReact
        data={seekArrowData}
        autoplay
        loop={false}
        style={{width: '100%', height: '100%'}}
      />
    </View>
  )
}

const styles = StyleSheet.create({
  flip: {transform: [{scaleX: -1}]},
  staticWrap: {
    alignItems: 'center',
    justifyContent: 'center',
  },
})
